import { useCallback, useEffect, useState } from 'react';
import { getAllJobsFromDB, Job } from 'utils/indexedDBUtils';
import { captureException } from 'utils/captureException';

const useJobsIndexedDB = ({
  disabled,
  reset,
}: {
  disabled?: boolean;
  reset?: boolean;
}) => {
  const [data, setData] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const dataFromDB = await getAllJobsFromDB();
      setData(dataFromDB);
    } catch (error) {
      captureException(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!disabled) {
      fetchData();
    }
  }, [disabled, fetchData, reset]);

  return { data, loading, refetch: fetchData };
};

export default useJobsIndexedDB;
